export const FILTER_ITEM_NODES = [
  { value: "C", label: "C" },
  { value: "E", label: "E" },
  { value: "F", label: "F" },
  { value: "L", label: "L" },
  { value: "R", label: "R" },
  { value: "V", label: "V" },
  { value: "U", label: "U" },
];

export const ALL_ITEMS_ORDERED = [
  { value: "ITMATT", label: "ITMATT" },
  { value: "EMA", label: "EMA" },
  { value: "EMB", label: "EMB" },
  { value: "EMC", label: "EMC" },
  { value: "PREDES", label: "PREDES" },
  { value: "PRECON", label: "PRECON" },
  { value: "CARDIT", label: "CARDIT" },
  { value: "EMJ", label: "EMJ" },
  { value: "EMK", label: "EMK" },
  { value: "MRD_POD", label: "MRD POD" },
  { value: "EMD", label: "EMD" },
  { value: "EDB", label: "EDB" },
  { value: "EME", label: "EME" },
  { value: "EDC", label: "EDC" },
  { value: "EMF", label: "EMF" },
  { value: "EDX", label: "EDX" },
  { value: "EDH", label: "EDH" },
  { value: "EMH", label: "EMH" },
  { value: "EMI", label: "EMI" },
];

export const BASE_MISSING_ITEMS = [
  { value: "ITMATT", label: "ITMATT" },
  { value: "EMA", label: "EMA" },
  { value: "EMC", label: "EMC" },
  { value: "PREDES", label: "PREDES" },
  { value: "CARDIT", label: "CARDIT" },
  { value: "EMJ", label: "EMJ" },
  { value: "EMD", label: "EMD" },
  { value: "EDX", label: "EDX" },
  { value: "EDH", label: "EDH" },
  { value: "EMH", label: "EMH" },
  { value: "EMI", label: "EMI" },
];

export const ADDITIONAL_OVERVIEW_OPTIONS = [
  { value: "EMB", label: "EMB" },
  { value: "PRECON", label: "PRECON" },
  { value: "EMK", label: "EMK" },
  { value: "MRD_POD", label: "MRD POD" },
  { value: "EDB", label: "EDB" },
  { value: "EME", label: "EME" },
  { value: "EDC", label: "EDC" },
  { value: "EMF", label: "EMF" },
  { value: "MRD_POC", label: "MRD POC" },
];

// One checkbox that matches items with any of these events; "Only show items with" only
export const COMBINED_WITH_OPTIONS = [
  { value: "EMI_EMH_EDH_EDX", label: "EMI-EMH-EDH-EDX" },
];

const REPORT_EXCLUSIONS = {
  ITEM_OVERVIEW_V1_200: ["MRD_POC"],
  ITEM_OVERVIEW_V2_201: ["CARDIT", "PRECON", "MRD_POD", "MRD_POC"],
};

export const getAllItemOptions = (selectionCriteriaCode, reportId) => {
  if (selectionCriteriaCode !== "SC100_OVERVIEW") {
    return ALL_ITEMS_ORDERED.filter((item) =>
      BASE_MISSING_ITEMS.some((baseItem) => baseItem.value === item.value)
    );
  }

  const exclusions = REPORT_EXCLUSIONS[reportId] || [];
  return ALL_ITEMS_ORDERED.filter((item) => !exclusions.includes(item.value));
};

export const getWithItemOptions = (selectionCriteriaCode, reportId) => [
  ...getAllItemOptions(selectionCriteriaCode, reportId),
  ...COMBINED_WITH_OPTIONS,
];
